<template>
    <div class="text-left">
        <b-form v-show="isEnabled">
            <b-row class="mb-2">
                <b-col sm="12" md="6" class="mt-1">
                    <label class="text-uppercase mb-0">Vorname*</label>
                    <b-form-input  class="mt-0 InputBorder"             
                        type="text" :id="idPrefix + 'firstname'"
                        v-model="address.firstname"
                        required 
                        :state="firstnameState" 
                        :class="{'is-invalid' : !address.firstnameIsValid}" 
                        aria-describedby="input-live-feedback"
                        placeholder="Vorname" />
                    <b-form-invalid-feedback id="input-live-feedback">
                        min. {{addressValidation.firstname.MinLetters }} Buchstaben
                    </b-form-invalid-feedback>
                                        
                </b-col>
                <b-col sm="12" md="6" class="mt-1">
                    <label class="text-uppercase mb-0">Nachname*</label>
                    <b-form-input  class="mt-0 InputBorder"                   
                        type="text" :id="idPrefix + 'lastname'"
                        v-model="address.lastname"
                        :state="lastnameState"
                        :class="{'is-invalid' : !address.lastnameIsValid}" 
                        aria-describedby="input-live-feedback"  
                        required
                        placeholder="Nachname" />
                    <b-form-invalid-feedback id="input-live-feedback">
                        min. {{addressValidation.lastname.MinLetters }} Buchstaben
                    </b-form-invalid-feedback>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col class="mt-1">
                    <label class="text-uppercase mb-0">Straße / Nr.*</label>
                    <b-form-input class="mt-0 InputBorder"                   
                        type="text" 
                        v-model="address.street"
                        required aria-describedby="input-live-feedback"  
                        :state="streetState" :id="idPrefix + 'street'"
                        :class="{'is-invalid' : !address.streetIsValid}"
                        placeholder="Straße / Nr." />
                    <b-form-invalid-feedback id="input-live-feedback">
                        min. {{addressValidation.street.MinLetters }} Buchstaben
                    </b-form-invalid-feedback>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                
                <b-col sm="12" md="6" class="mt-1">
                    <label class="text-uppercase mb-0">Postleitzahl*</label>
                    <b-form-input  class="mt-0 InputBorder"                  
                        type="text"
                        v-model="address.zip" :id="idPrefix + 'zip'"
                        required
                        aria-describedby="input-live-feedback"  
                        :state="zipState"
                        :class="{'is-invalid' : !address.zipIsValid}"
                        placeholder="PLZ" />
                    <b-form-invalid-feedback id="input-live-feedback">
                        min. {{addressValidation.zip.MinLetters }} Buchstaben
                    </b-form-invalid-feedback>
                </b-col>
                <b-col sm="12" md="6" class="mt-1">
                    <label class="text-uppercase mb-0">Stadt*</label>
                    <b-form-input  class="mt-0 InputBorder"                   
                        type="text"
                        v-model="address.city"
                        required :id="idPrefix + 'city'"
                        aria-describedby="input-live-feedback" 
                        :state="cityState"
                        :class="{'is-invalid' : !address.cityIsValid}"
                        placeholder="Stadt" />
                    <b-form-invalid-feedback id="input-live-feedback">
                        min. {{addressValidation.city.MinLetters }} Buchstaben
                    </b-form-invalid-feedback>    
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col class="mt-1">
                    <label class="text-uppercase mb-0">Land*</label>
                    <b-form-input class="mt-0 InputBorder"                   
                        type="text"
                        v-model="address.country"
                        required :id="idPrefix + 'country'"
                        :state="countryState"
                         :class="{'is-invalid' : !address.countryIsValid}"
                        placeholder="Land"/>
                    <b-form-invalid-feedback id="input-live-feedback">
                        min. {{addressValidation.country.MinLetters }} Buchstaben
                    </b-form-invalid-feedback>
                </b-col>            
            </b-row>

        </b-form>
    </div>
</template>

<script>
export default {
    name: 'ShopCustomerAddressInputs',
    props: [
        'address','enabled', 'addressValidation', 'idPrefix'
    ],
    data(){
        return{
           
        }
    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault()
           // alert(JSON.stringify(this.form))            
        },
        onReset(evt) {
            evt.preventDefault()
            /* Reset our form values */
            this.address.firstname = '';
            this.address.lastname = '';
            this.address.street = '';
            this.address.zip = '';
            this.address.city = '';
            this.address.country = '';
        },
        setIsValid(item){            
            this.address[item] = true;
           // console.log('TRUE validated: ',item, this.address[item]);
            
            return item;
        },
        setIsInvalid(item){            
            this.address[item] = false;
            //console.log('FALSE validated: ', item, this.address[item]);
            return item;
        },
               
    },
    computed: {
        isEnabled(){
           // console.log('enabled: ', this.enabled);
            
            // bloody strings ?!
            if(this.enabled == 'true'){
               // console.log('Address enabled');  
                return true;
            }else if(this.enabled == 'false'){
               // console.log('Address disabled');                    
                return false;
            }else if(this.enabled == true){
               // console.log('TRUE ', this.enabled);
                return true;
            }else{
                return false;
            }
        },
        firstnameState(){ 
            if (this.address.firstname.length == 0) {
                return undefined;
            }else if(this.address.firstname.length > (this.addressValidation.firstname.MinLetters -1) ){
               
                this.setIsValid("firstnameIsValid");
                return true;
            }else{

                this.setIsInvalid("firstnameIsValid");
                return false;
            }
        },
        lastnameState(){
            if (this.address.lastname.length == 0) {
                return undefined;
            }else if(this.address.lastname.length > (this.addressValidation.lastname.MinLetters -1) ){

                this.setIsValid("lastnameIsValid");
                return true;
            }else{
                this.setIsInvalid("lastnameIsValid");
                return false;
            }            
        },
        streetState(){
            if (this.address.street.length == 0) {
                return undefined;
            }else if(this.address.street.length > (this.addressValidation.street.MinLetters -1) ){
                this.setIsValid("streetIsValid");
                return true;
            }else{
                this.setIsInvalid("streetIsValid");
                return false;
            }   
        },
        zipState(){
            if (this.address.zip.length == 0) {
                return undefined;
            }else if(this.address.zip.length > (this.addressValidation.zip.MinLetters -1) ){
                this.setIsValid("zipIsValid");
                return true;
            }else{
                this.setIsInvalid("zipIsValid");
                return false;
            }  
        },
        cityState(){
            if (this.address.city.length == 0) {
                return undefined;
            }else if(this.address.city.length > (this.addressValidation.city.MinLetters -1) ){
                this.setIsValid("cityIsValid");
                return true;
            }else{
                this.setIsInvalid("cityIsValid")
                return false;
            }
        },
        countryState(){
            if (this.address.country.length == 0) {
                return undefined;
            }else if(this.address.country.length > (this.addressValidation.country.MinLetters -1) ){
                this.setIsValid("countryIsValid");  
                return true;
            }else{
                 this.setIsInvalid("countryIsValid")
                return false;
            }
        },
    },
    beforeMount(){
        //console.log('idPrefix: ', this.idPrefix);
        //
     
    }

}
</script>
